export const translations = {
    en: {
        nav: {
            home: "Home",
            work: "Work",
            contact: "Contact",
            back: "← Back"
        },
        contact: {
            title: "Contact",
            name: "Name",
            email: "Email",
            subject: "Subject",
            message: "Message",
            send: "Send Message",
            sending: "Sending...",
            successMessage: "Message sent successfully! I will get back to you soon.",
            errorMessage: "Oops! Something went wrong. Please try emailing directly.",
            getInTouch: "Get in Touch"
        },
        about: {
            title: "About Me",
            bio1: "Sara is a graphic designer operating at the intersection of visual communication, development, and user experience. With a National Craft Certificate (Svennebrev) in Graphic Design and a degree in Graphic Design (with Creative Computing) from UAL, she combines technical design precision with an exploratory approach to interaction design and modern technology.",
            bio2: [
                "Through her experience at the Norwegian Industrial Property Office (Patentstyret) and Hoopit, she has developed a methodology that unites strategic branding with technical realisation. She is dedicated to challenging standardised solutions through personalised interfaces and universal design. By using code and data as creative tools, she builds tailored digital experiences that put the user at the centre.",
                "Her background in the service industry has equipped her with the ability to communicate effectively and thrive in fast-paced environments. Beyond the screen, she spends her time knitting and on other personal projects that require patience and a keen eye for detail."
            ],
            getInTouch: "Get in Touch"
        },
        sidebar: {
            theme: "Theme",
            color: "Accent",
            lang: "Language"
        },
        home: {
            greeting: "Hello, I'm",
            tagline: "I am passionate about intuitive user experiences through functional design and visual identities.",
            roles: "Design • User Experience • Development",
            selectedWork: "Selected Work",
            viewAll: "View All Work →"
        },
        work: {
            title: "Selected Work",
            viewProject: "View Project",
            client: "Client",
            role: "Role",
            visitWebsite: "Visit Website",
            websiteLabel: "Website",
            filters: {
                all: "All",
                digital_design: "Digital Design",
                branding: "Branding",
                print: "Print"
            }
        }
    },
    no: {
        nav: {
            home: "Hjem",
            work: "Prosjekter",
            contact: "Kontakt",
            back: "← Tilbake"
        },
        contact: {
            title: "Kontakt",
            name: "Navn",
            email: "E-post",
            subject: "Emne",
            message: "Melding",
            send: "Send melding",
            sending: "Sender...",
            successMessage: "Meldingen ble sendt! Jeg tar kontakt snart.",
            errorMessage: "Oisann! Noe gikk galt. Vennligst prøv å sende e-post direkte i stedet.",
            getInTouch: "Ta kontakt"
        },
        about: {
            title: "Om meg",
            bio1: "Sara er en grafisk designer som opererer i skjæringspunktet mellom visuell kommunikasjon, utvikling og brukeropplevelse. Med et svennebrev i mediegrafikerfaget og en grad i Graphic Design (with Creative Computing) fra UAL, kombinerer hun teknisk presisjon med en utforskende tilnærming til interaksjonsdesign og moderne teknologi.",
            bio2: [
                "Gjennom sin erfaring fra Patentstyret og Hoopit, har hun utviklet en arbeidsmetodikk som forener strategisk merkevarebygging med teknisk realisering. Hun brenner for å utfordre standardiserte løsninger gjennom personaliserte grensesnitt og universell utforming. Ved å bruke kode og data som kreative verktøy, bygger hun skreddersydde digitale opplevelser som setter brukeren i sentrum.",
                "Hennes bakgrunn fra servicebransjen har gitt henne evnen til å kommunisere effektivt og trives i prosjekter med høyt tempo. Når hun ikke sitter foran skjermen, bruker hun tiden på strikking og andre personlige prosjekter som krever tålmodighet og fokus på detaljer."
            ],
            getInTouch: "Ta kontakt"
        },
        sidebar: {
            theme: "Tema",
            color: "Aksent",
            lang: "Språk"
        },
        home: {
            greeting: "Hei, jeg heter",
            tagline: "Jeg brenner for intuitive brukeropplevelser gjennom funksjonelt design og visuelle identiteter.",
            roles: "Design • Brukeropplevelse • Utvikling",
            selectedWork: "Utvalgte Prosjekter",
            viewAll: "Se Alle Prosjekter →"
        },
        work: {
            title: "Utvalgte Prosjekter",
            viewProject: "Se Prosjekt",
            client: "Kunde",
            role: "Rolle",
            visitWebsite: "Besøk nettside",
            websiteLabel: "Nettside",
            filters: {
                all: "Alle",
                digital_design: "Digitalt design",
                branding: "Visuell identitet",
                print: "Print"
            }
        }
    }
};
